export default "__VITE_ASSET__109f58b4__"